import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SaLogoComponent } from './sa-logo/sa-logo.component';
import { ControlsModule } from "../controls/controls.module";
import { GlobalSearchModule } from '../global-search/global-search.module';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SaLogoComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    ControlsModule,
    GlobalSearchModule
],
  exports: [
    HeaderComponent,
    FooterComponent,
    SaLogoComponent
  ]
})
export class LayoutsModule { }
